/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_Form_LabelInputs */

const en_subtitle_import_form_label = /** @type {(inputs: Subtitle_Import_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitle import form`)
};

const fr_subtitle_import_form_label = /** @type {(inputs: Subtitle_Import_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulaire d'importation des sous-titres`)
};

const de_subtitle_import_form_label = /** @type {(inputs: Subtitle_Import_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitel-Importformular`)
};

const it_subtitle_import_form_label = /** @type {(inputs: Subtitle_Import_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modulo di importazione dei sottotitoli`)
};

const ru_subtitle_import_form_label = /** @type {(inputs: Subtitle_Import_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Форма импорта субтитров`)
};

const es_subtitle_import_form_label = /** @type {(inputs: Subtitle_Import_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulario de importación de subtítulos`)
};

const zh_cn2_subtitle_import_form_label = /** @type {(inputs: Subtitle_Import_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕导入表单`)
};

const ja_subtitle_import_form_label = /** @type {(inputs: Subtitle_Import_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕インポートフォーム`)
};

const hi_subtitle_import_form_label = /** @type {(inputs: Subtitle_Import_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक आयात फ़ॉर्म`)
};

const pt_pt2_subtitle_import_form_label = /** @type {(inputs: Subtitle_Import_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulário de importação de legendas`)
};

/**
* | output |
* | --- |
* | "Subtitle import form" |
*
* @param {Subtitle_Import_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_form_label = /** @type {((inputs?: Subtitle_Import_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_import_form_label(inputs)
	if (locale === "de") return de_subtitle_import_form_label(inputs)
	if (locale === "it") return it_subtitle_import_form_label(inputs)
	if (locale === "ru") return ru_subtitle_import_form_label(inputs)
	if (locale === "es") return es_subtitle_import_form_label(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_import_form_label(inputs)
	if (locale === "ja") return ja_subtitle_import_form_label(inputs)
	if (locale === "hi") return hi_subtitle_import_form_label(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_import_form_label(inputs)
	return en_subtitle_import_form_label(inputs)
});